const periods = {
  Sunrise: 'sunrise',
  Morning: 'morning',
  Noon: 'noon',
  Sunset: 'sunset',
  Night: 'night',
};

export default periods;
